import { render, staticRenderFns } from "./news_list.vue?vue&type=template&id=aed0a0e6&scoped=true"
import script from "./news_list.vue?vue&type=script&lang=js"
export * from "./news_list.vue?vue&type=script&lang=js"
import style0 from "./news_list.vue?vue&type=style&index=0&id=aed0a0e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed0a0e6",
  null
  
)

export default component.exports